// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import genRequest from "includes/request";
import UserRow from "components/User/UserRow/UserRow";
import Tabs from "components/Tabs/Tabs";
import { ReactionButton } from "Pages/Reactions/AdminReactionsPage";
import LoadCont from "components/LoadCont/LoadCont";
import { t } from "i18next";
import Summary from "components/Summary/Summary";
import ReactionIcon from "Pages/Reactions/components/ReactionIcon/ReactionIcon";
import useAccount from "classes/Accounts/hooks/useAccount";

export default function ReactionsStats(props) {
	const treat_reactions = (reacts) => {
		let res = [];

		if (!reacts) return res;

		reacts.forEach((a) => {
			let index = res.findIndex((b) => b.reactionId === a.reactionId);

			if (index === -1)
				res.push({
					reactionId: a.reactionId,
					PostId: a.postId,
					count: 1,
					reactions: [a],
				});
			else {
				res[index].count++;
				res[index].reactions.push(a);
			}
		});
		return res;
	};

	const fetchLikes = () =>
		genRequest("posts/" + props.postId + "/likes")
			.then((resp) => (resp ? resp : []))
			.catch((e) => []);

	const fetchReactions = () =>
		genRequest("posts/" + props.postId + "/reactions")
			.then((resp) => (resp ? resp : []))
			.catch((e) => []);

	const fetch = () => {
		let proms = [fetchLikes(), fetchReactions()];

		let prom = Promise.all(proms).then((resp) => {
			let all = [];
			if (resp[0]?.length) all.push(...resp[0]);
			if (resp[1]?.length) all.push(...resp[1]);
			return {
				all: all,
				likes: resp[0],
				reactions: resp[1],
				sortedReactions: treat_reactions(resp[1]),
				totalCount: resp[0]?.length + resp[1].length,
			};
		});
		return prom;
	};

	const { isLoading, data } = useQuery(
		["PostReactionsFetch", "PostId", props.postId],
		fetch
	);

	if (isLoading) return <div>{t("Commons.LOADING")}</div>;

	if (props.children)
		return !data.totalCount
			? 0
			: props.children({
				...data,
				postId: props.postId,
			});

	if (props.hideIfNull && !data.totalCount) {
		if (props.onHide) props.onHide();
		return false;
	}

	return (
		<div className="pb-3">
			<div style={{ fontSize: "16px" }} className="text-center mb-1">
				{t("Posts.REACTIONS", { count: data?.totalCount })}
			</div>
			{data.totalCount > 0 && (
				<ReactionsTable
					postId={props.postId}
					count={data.totalCount}
					reactions={data.sortedReactions}
					likes={data.likes}
					all={data.all}
				/>
			)}
		</div>
	);
}

function ReactionsTable(props) {
	const { reactions, postId, likes } = props;
	const { account } = useAccount();
	const [tabs, setTabs] = useState([]);

	useEffect(() => {
		setTabs([
			{
				title: (
					<div className="d-flex gap-2 align-items-center justify-content-center w-100 h-100">
						{t("Analytics.ALL")}
					</div>
				),
				child: AllTab,
				childProps: {
					items: props.all.sort((a, b) =>
						a.lastChanged < b.lastChanged ? -1 : 1
					),
				},
				isVisible: true,
			},
			{
				title: (
					<div className="d-flex gap-2 align-items-center justify-content-center w-100 h-100">
						<FontAwesomeIcon
							icon={faHeart}
							color={"#ff0045"}
							style={{ fontSize: "16px" }}
						/>
						{likes.length}
					</div>
				),
				child: Likes,
				childProps: {
					count: likes.length,
					postId,
				},
				enabled: likes.length > 0,
				hoverTitle: "Likes",
				isVisible: true,
			},
		]);
		return () => {
			setTabs([]);
		}
	}, [account]);

	reactions.forEach((a) => {
		tabs.push({
			title: (
				<ReactionButton
					asyncIcon={true}
					id={a.reactionId}
					countQueryKey={[
						"posts",
						postId,
						"reactions",
						a.reactionId,
					]}
					countQueryFn={() =>
						genRequest(
							"posts/" +
							postId +
							"/reactions/" +
							a.reactionId
						)
					}
					iconStyle={{
						width: "25px",
					}}
					className="d-flex flex-row align-items-center gap-2 pe-none justify-content-center h-100"
				/>
			),
			child: ReactionUsers,
			childProps: {
				users: a.reactions,
			},
			isVisible: true,
		});
	});

	return <Tabs className="ReactionsTable light-bg" items={tabs} />;
}

function AllTab(props) {
	const { items } = props;

	const treat_reactions = (reacts) => {
		let res = [];

		if (!reacts) return res;

		reacts.forEach((a) => {
			let index = res.findIndex((b) => b.employeeId === a.employeeId);

			if (index === -1)
				res.push({
					employeeId: a.employeeId,
					PostId: a.postId,
					count: 1,
					reactions: [a],
				});
			else {
				res[index].count++;
				res[index].reactions.push(a);
			}
		});
		return res;
	};

	if (!items?.length) return <div>{t("Posts.REACTIONS", { count: 0 })}</div>;

	let disp_items = treat_reactions(items);

	return (
		<div>
			{disp_items.map((a, key) => {
				return (
					<UserRow
						key={a.employeeId}
						user={{ employeeId: a.employeeId }}
						status={false}
					>
						<div
							className="d-flex align-items-center justify-content-center me-2 gap-1"
							style={{}}
						>
							{a.reactions
								.sort((c, d) => {
									if (!c.reactionId) return -1;
									return c.reactionId < d.reactionId ? -1 : 1;
								})
								.map((b, b_key) =>
									b.reactionId ? (
										<ReactionIcon
											async={true}
											id={b.reactionId}
											style={{
												width: "20px",
											}}
										/>
									) : (
										<FontAwesomeIcon
											icon={faHeart}
											color={"red"}
										/>
									)
								)}
						</div>
					</UserRow>
				);
			})}
		</div>
	);
}

function ReactionUsers(props) {
	const { users } = props;

	return (
		<div>
			{users
				?.sort((a, b) => (a.lastChanged < b.lastChanged ? -1 : 1))
				.map((a) => (
					<UserRow
						key={a.employeeId}
						user={{ employeeId: a.employeeId }}
						status={false}
					/>
				))}
		</div>
	);
}

export function Likes({ count, postId, summary }) {
	const { isLoading, data, error } = useQuery(
		["PostsStats", "posts", postId, "likes"],
		() => genRequest("posts/" + postId + "/likes")
	);

	const genItems = () => {
		if (isLoading) return <LoadCont text="Chargement des likes" />;
		if (!data?.length || error) return <div>{t("Posts.NO_LIKES")}</div>;
		return (
			<div
				className="w-100"
				style={{ maxHeight: "300px", overflow: "auto" }}
			>
				{data
					?.sort((a, b) => (a.lastChanged < b.lastChanged ? -1 : 1))
					.map((a) => (
						<UserRow
							key={a.employeeId}
							user={{ employeeId: a.employeeId }}
							status={false}
						/>
					))}
			</div>
		);
	};

	if (summary)
		return (
			<Summary
				title={count + " " + t("Posts.LIKES", { count })}
				icon={faHeart}
				items={genItems()}
			/>
		);
	return genItems();
}
